import * as tracking from 'dibs-tracking';

const { EVENT_SELLER_APPLICATION } = tracking.eventNameConstants;

type TTrackSellerApplicationEventProps = {
    type: 'professional' | 'individual' | 'main';
    action: string;
    stepInteractionType: string;
    interactionName: string;
};

export const trackSellerApplicationEvent = ({
    type,
    action,
    interactionName,
    stepInteractionType,
}: TTrackSellerApplicationEventProps): void => {
    tracking.trackEvent({
        category: EVENT_SELLER_APPLICATION,
        action: `${type} application ${action}`,
        label: `seller application - ${type}`,
        isInteractiveEvent: true,
        eventName: EVENT_SELLER_APPLICATION,
        interaction_type: interactionName,
        step_interaction_name: stepInteractionType,
        trigger: type,
    });
};
